export class DeleteConfirmation {
    public EntityType = '';
    public FriendlyName = '';
    public Confirmed = false;
    public EntityId = 0;
}
